export const banners = [
  {
    title: 'history.banner-title1',
    description: 'history.banner-desc1',
  },
  {
    title: 'history.banner-title2',
    description: 'history.banner-desc2',
  },
/*   {
    title: "history.banner-title3",
    description: "history.banner-desc3",
  }, */
]
